if(!customElements.get('enter-password')) {
    class EnterPassword extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback(){
            this.buttonPopup = this.querySelector(".button-enter-password");
            if(this.buttonPopup){
                this.buttonPopup.addEventListener('click', this.openPasswordPopup.bind(this));
            }
        }

        openPasswordPopup(e){
            if(e){
                e.preventDefault();
            }

            const passwordPopup = document.querySelector('password-popup');
            if(passwordPopup){
                passwordPopup.openPopup();
            }
        }
    }

    customElements.define('enter-password', EnterPassword);
}

if(!customElements.get('password-popup')) {
    class PasswordPopup extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback(){
            this.previouslyFocusedElement = document.activeElement;

            this.buttons = this.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

            this.popupOnload = this.querySelectorAll(".input-error").length > 0? true : false;
            if(this.popupOnload){
                this.openPopup();
            }

            // close popup
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.closePopup.bind(this));
                item.addEventListener("keydown", e => {
                    if(e.code === 'Enter'){
                        this.closePopup();
                    }
                });
            });
            this.addEventListener('click', e => {
                if(e.target === this) this.closePopup();
            });
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE') this.closePopup();
            });
        }

        openPopup(e = null){
            if(e){
                e.preventDefault();
            }

            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            this.previouslyFocusedElement = document.activeElement;

            FocusTrap.activate(this);
            this.addFocus();
        }

        closePopup(){
            FocusTrap.deactivate(this);

            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        addFocus(){
            if(this.buttons.length > 0){
                setTimeout(() => {
                    this.buttons[0].focus();
                }, 100);
            }
        }
    }

    customElements.define('password-popup', PasswordPopup);
}